import Link from "next/link";
import { signOut } from "next-auth/react";

/**
 * Componente UserMenu que renderiza el menú de usuario con opciones de suscripción y logout.
 *
 * @returns {JSX.Element} - Renderizado del menú de usuario.
 */
const UserMenu = () => {
  /**
   * Maneja el logout del usuario.
   * Previene el comportamiento por defecto, cierra la sesión y actualiza localStorage para sincronizar el logout.
   *
   * @param {React.MouseEvent} e - Evento del clic.
   */
  const handleLogout = (e) => {
    e.preventDefault();
    // Cierra la sesión y redirige a la página de "Iniciar sesión".
    signOut({ callbackUrl: "/iniciar-sesion" });
    // Guarda la hora del logout en localStorage para sincronización entre ventanas.
    localStorage.setItem("logout-tutorIA", Date.now());
  };

  return (
    <div className="inner">
      <ul className="user-list-wrapper user-nav">
        <li>
          <Link href="/cuenta/suscripcion">
            <i className="fa-solid fa-credit-card"></i>
            <span>Suscripción</span>
          </Link>
        </li>
      </ul>
      <hr className="mt--10 mb--10" />
      <ul className="user-list-wrapper">
        <li>
          <a href="/cerrar-sesion" onClick={handleLogout}>
            <i className="fa-sharp fa-solid fa-right-to-bracket"></i>
            <span>Cerrar sesión</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default UserMenu;
